const For = {}

/* SINGLE LANGUAGE SITE */

/* GENERAL QUERY STRUCTURE FOR IMAGES */
For.Images = {
  query: 'page.images',
  select: {
    id: true,
    filename: true,
    url: true,
    width: 'file.width()',
    height: 'file.height()',
    ratio: 'file.ratio()',
    srcset: 'file.srcset([250, 450, 800, 1440, 2880])',
  }
};

/* COVER IMAGE FOR LIST HOVER PREVIEWS
   Uses the first image block's file so the index preview is the exact same
   image as the project's first slide — required for the seamless crossfade. */
For.Cover = {
  query: 'page.firstImageFile',
  select: {
    filename: true,
    url: true,
    width: 'file.width()',
    height: 'file.height()',
    srcset: 'file.srcset([250, 450, 800, 1440, 2880])',
  }
};

/* BASE FIELDS FOR PAGES */
const Base = {
  title: true,
  content: true,
  url: true,
  id: true,
  uid: true,
  template: 'page.intendedTemplate()',
  listed: 'page.isListed',
};

/* GENERAL QUERY STRUCTURE FOR CHILDREN (no cover — applied to all pages incl. diary years) */
For.Children = {
  ...Base,
  children: {
    query: 'page.children.listed',
    select: Base
  }
};

/* INDEX PROJECTS WITH COVERS — fetched separately so only project pages get the cover query */
For.Projects = {
  ...Base,
  cover: For.Cover,
};

/* PAGES */
/* ===== */

For.Default = {
  ...Base,
  images: For.Images,
}

/* Cover slideshow */
For.Home = {
  ...Base,
  images: For.Images,
}

/* Shared file select for image blocks */
const BlockFileSelect = {
  filename: true,
  url: true,
  width: 'file.width()',
  height: 'file.height()',
  ratio: 'file.ratio()',
  srcset: 'file.srcset([250, 450, 800, 1440, 2880])',
};

/* Shared blocks query: resolves image files within image-type blocks */
const BlocksSelect = {
  query: 'page.blocks.toBlocks',
  select: {
    id: true,
    type: true,
    content: true,
    /* For image-type blocks, resolve file objects via block.image.toFiles */
    files: {
      query: 'block.image.toFiles',
      select: BlockFileSelect,
    }
  }
};

/* Project slideshow: each block is a slide; image blocks get files resolved via KQL */
For.Project = {
  ...Base,
  images: For.Images,
  blocks: BlocksSelect,
}

/* Work index: archive structure is in content (YAML), parsed client-side */
For.Index = {
  ...Base,
}

/* Information: bio */
For.Information = {
  ...Base,
  text: 'page.text.kirbytext',
}

/* Diary list: all entries with blocks for inline rendering, grouped by year client-side */
For.Diary = {
  ...Base,
  children: {
    query: 'page.children.listed',
    select: {
      uid: true,
      title: true,
      date: 'page.date.toDate("Y-m-d")',
      blocks: BlocksSelect,
    },
  },
}

/* Diary entry: blocks + date + siblings for prev/next navigation */
For.DiaryEntry = {
  ...Base,
  date: 'page.date.toDate("j M Y")',
  blocks: BlocksSelect,
  siblings: {
    query: 'page.parent.children.listed',
    select: { uid: true, title: true, date: 'page.date.toDate("Y-m-d")' },
  },
}

For.Site = {
  title: true,
  url: true,
  content: true,
  featuredprojects: {
    query: 'site.featuredprojects.toPages',
    select: {
      title: true,
      uid: true,
      id: true,
      url: true,
      cover: For.Cover,
    }
  }
}

export default {
  For
}
